export const eur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(n || 0));

export const dateIt = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return iso; }
};

export const statusLabel = {
  bozza: "Bozza",
  inviato: "Inviato",
  in_verifica: "In verifica",
  confermato: "Confermato",
  completato: "Completato",
  annullato: "Annullato",
  iscritto: "Iscritto",
  in_attesa: "In attesa",
  pagato: "Pagato",
};
